export default __webpack_public_path__ + "static/media/cryptoEngagement.feeb4495.jpg";